import React, { useState } from "react";
import appConfig from "../../constants/config";
import { shrinkCostCenter, subCatInputOnChange } from "../../pages/ClaimItems/services/claimDetailUtils";
import { disableInput, elementDisplay, isElementVisible, mandatoryInput } from "../../utils/elementControl";

const isNullOrEmpty = (value: any): boolean =>
  value == null || value.toString() === "" || value === undefined;

interface APeventProps {
  i: number | undefined;
  id: any;
}

export const AddAPevent: React.FC<APeventProps> = ({ i, id }): any => {
  const [visibleGroups, setVisibleGroups] = useState<{
    [key: string]: boolean;
  }>(
    Array.from({ length: 15 }, (_, index) => index + 1).reduce((acc, num) => {
      acc[`${num}_${i}`] = num === 1;
      return acc;
    }, {} as { [key: string]: boolean })
  );

  const [, suffix] = id.split("SPR");
  const [NumberOfSO, NumberOfPage] = suffix.split("_");
  const maxGroups = 15;

  for (let a = Number(NumberOfSO); a <= maxGroups; a++) {
    const key = `${a}_${NumberOfPage}`;
    if (!visibleGroups[key]) {
      setVisibleGroups({ ...visibleGroups, [key]: true });
      break;
    }
  }

  // Trigger change event
  const ddlExceedraNoCode1 = document.getElementById(
    "ddlExceedraNoCode1"
  ) as HTMLInputElement;
  if (ddlExceedraNoCode1) {
    const event = new Event("change", { bubbles: true });
    ddlExceedraNoCode1.dispatchEvent(event);
  }
};

export const DelAPevent = (i: any, id: string) => {
  const [visibleGroups, setVisibleGroups] = useState<{
    [key: string]: boolean;
  }>(
    Array.from({ length: 15 }, (_, index) => index + 1).reduce((acc, num) => {
      acc[`${num}_${i}`] = num === 1;
      return acc;
    }, {} as { [key: string]: boolean })
  );

  const [prefix, suffix] = id.split("SPR");
  const [NumberOfSO, NumberOfPage] = suffix.split("_");
  const maxGroups = 15;

  for (let a = maxGroups; a >= 1; a--) {
    const key = `${a}_${NumberOfPage}`;
    if (visibleGroups[key]) {
      setVisibleGroups({ ...visibleGroups, [key]: false });

      const txtAPCeventID = document.getElementById(
        `txtAPCeventID${a}_${NumberOfPage}`
      ) as HTMLInputElement;
      const txtAPeventPercent = document.getElementById(
        `txtAPeventPercent${a}_${NumberOfPage}`
      ) as HTMLInputElement;

      if (txtAPCeventID) {
        txtAPCeventID.required = false;
        txtAPCeventID.value = "";
      }

      if (txtAPeventPercent) {
        txtAPeventPercent.required = false;
        txtAPeventPercent.value = "";
      }

      break;
    }
  }
};

export const handleddlExceedraNoCodeChange = (
  i: any,
  selectedValue: string | undefined,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>
) => {
  checkNoAPEventCode(inputValues, handleInputChange);

  const isDisabled = selectedValue == "0" ? true : false;
  for (let iCounter = 1; iCounter < 5; iCounter++) {
    const ddlCC = document.getElementById(
      `ddlCC${iCounter}_${i}`
    ) as HTMLSelectElement;
    const txtCCPercent = document.getElementById(
      `txtCCPercent${iCounter}_${i}`
    ) as HTMLInputElement;

    if (ddlCC) ddlCC.disabled = isDisabled;
    if (txtCCPercent) txtCCPercent.disabled = isDisabled;
  }
};

export const checkNoAPEventCode = (
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  currentOnChangeInput: string | undefined | null = "",
  claimable: string = "0",
  itemIndex: number = 1 //Begin,Saber,20261021,INC-1059599 - Apply the no-Exceedra rule to the current claim item
) => {
  let i = itemIndex || 1;
  let checkIsAPEventCode = currentOnChangeInput;
  let checkClaimable = claimable;

  if (isNullOrEmpty(checkIsAPEventCode)) {
    if (!isNullOrEmpty(inputValues[`ddlExceedraNoCode${i}`])) {
      checkIsAPEventCode = inputValues[`ddlExceedraNoCode${i}`]?.toString();
    } else {
      checkIsAPEventCode = "1";
    }
  }

  if (isNullOrEmpty(checkClaimable)) {
    if (!isNullOrEmpty(inputValues[`chkClaimable${i}`])) {
      checkClaimable = inputValues[`chkClaimable${i}`]?.toString();
    } else {
      checkClaimable = "0";
    }
  }


  const APCevent = document.querySelector<HTMLElement>(
    `#APCevent${i}`
  );

  const objectRequestorJsonString = localStorage.getItem("objRequestor")!;
  const objectRequestor = objectRequestorJsonString
    ? JSON.parse(objectRequestorJsonString)
    : null;

  elementDisplay(`#divAPCeventClaimable${i}`, false, "div");
  elementDisplay(`#divClientVendorCode${i}`, false, "div");
  elementDisplay(`#divAPCeventSpecialGL${i}`, false, "div");

  mandatoryInput(`#txtClientVendorCode${i}`, false, "text");
  disableInput(`#txtClientVendorCode${i}`, true, "text");

  mandatoryInput(`#ddlSpecialGL${i}`, false, "select");
  disableInput(`#ddlSpecialGL${i}`, true, "select");


  if (APCevent && !APCevent?.classList.contains("d-none")) {
    mandatoryInput(`#txtClientVendorCode${i}`, false, "text");
    disableInput(`#txtClientVendorCode${i}`, true, "text");

    mandatoryInput(`#ddlSpecialGL${i}`, false, "select");
    disableInput(`#ddlSpecialGL${i}`, true, "select");

    elementDisplay(`#divClientVendorCode${i}`, false, "div");
    elementDisplay(`#divAPCeventSpecialGL${i}`, false, "div");
    elementDisplay(`#divAPCeventClaimable${i}`, false, "div");


  }
  else {

    mandatoryInput(`#ddlCostElement${i}`, true, "select");
    disableInput(`#ddlCostElement${i}`, false, "select");

    elementDisplay(`#divClientVendorCode${i}`, false, "div");
    elementDisplay(`#divAPCeventSpecialGL${i}`, false, "div");
    elementDisplay(`#divAPCeventClaimable${i}`, false, "div");

  }


  if (APCevent && !APCevent?.classList.contains("d-none")) {
    if (claimable == "1") {

      mandatoryInput(`#txtClientVendorCode${i}`, true, "text");
      disableInput(`#txtClientVendorCode${i}`, false, "text");
      mandatoryInput(`#ddlSpecialGL${i}`, true, "select");
      disableInput(`#ddlSpecialGL${i}`, false, "select");

      elementDisplay(`#divClientVendorCode${i}`, true, "div");
      elementDisplay(`#divAPCeventSpecialGL${i}`, true, "div");


      shrinkCostCenter(`ddlCC1_${i}`, 1, inputValues, handleInputChange);
      shrinkCostCenter(`ddlCC2_${i}`, 1, inputValues, handleInputChange);
      shrinkCostCenter(`ddlCC3_${i}`, 1, inputValues, handleInputChange);
      shrinkCostCenter(`ddlCC4_${i}`, 1, inputValues, handleInputChange);

      //clear the value of the fields of cost center
      for (let iCounter = 1; iCounter < 5; iCounter++) {
        // const ddlCC = document.querySelector<HTMLInputElement>(`#ddlCC${iCounter}_${i}`);
        // const txtCCPercent = document.querySelector<HTMLInputElement>(`#txtCCPercent${iCounter}_${i}`);
        // ddlCC!.value = "";
        handleInputChange(`ddlCC${iCounter}_${i}`, "");
        // txtCCPercent!.value = "";
        handleInputChange(`txtCCPercent${iCounter}_${i}`, "");
      }
    } else {
      mandatoryInput(`#txtClientVendorCode${i}`, false, "text");
      disableInput(`#txtClientVendorCode${i}`, true, "text");
      mandatoryInput(`#ddlSpecialGL${i}`, false, "select");
      disableInput(`#ddlSpecialGL${i}`, true, "select");

      handleInputChange(`txtClientVendorCode${i}`, "");
      handleInputChange(`ddlSpecialGL${i}`, "");

    }

    if (checkIsAPEventCode == "1") {
      elementDisplay(`#divCostCenter${i}`, true, "div");
      elementDisplay(`#divProjectCode_${i}`, true, "div");
      elementDisplay(`#divAPCeventClaimable${i}`, true, "div");

      for (let a = 1; a <= 15; a++) {
        mandatoryInput(`#txtAPCeventID${a}_${i}`, false, "select");
        handleInputChange(`txtAPCeventID${a}_${i}`, "");
        disableInput(`#txtAPCeventID${a}_${i}`, true, "select");

        mandatoryInput(`#txtAPeventPercent${a}_${i}`, false, "text");
        handleInputChange(`txtAPeventPercent${a}_${i}`, "");
        disableInput(`#txtAPeventPercent${a}_${i}`, true, "text");
      }

      mandatoryInput(`#txtExceedraNoCodeRemarks${i}`, true, "text");
      disableInput(`#txtExceedraNoCodeRemarks${i}`, false, "text");


      //Begin,Saber,20261021,INC-1059599 - Require cost element when no Exceedra code, matching legacy
        mandatoryInput(`#ddlCostElement${i}`, true, "select");
        disableInput(`#ddlCostElement${i}`, false, "select");
      //End,Saber,20261021,INC-1059599
    } else {

      elementDisplay(`#divClientVendorCode${i}`, false, "div");
      elementDisplay(`#divAPCeventSpecialGL${i}`, false, "div");
      elementDisplay(`#divAPCeventClaimable${i}`, false, "div");

      handleInputChange(`chkClaimable${i}`, "0");

      mandatoryInput(`#txtClientVendorCode${i}`, false, "text");
      disableInput(`#txtClientVendorCode${i}`, true, "text");
      handleInputChange(`txtClientVendorCode${i}`, "");

      mandatoryInput(`#ddlSpecialGL${i}`, false, "select");
      disableInput(`#ddlSpecialGL${i}`, true, "select");
      handleInputChange(`ddlSpecialGL${i}`, "");

      for (let a = 1; a <= 15; a++) {
        if (document.querySelector<HTMLInputElement>(`#divAP${a}_${i}`) && !document.querySelector<HTMLInputElement>(`#divAP${a}_${i}`)?.classList.contains("d-none")) {
          mandatoryInput(`#txtAPCeventID${a}_${i}`, true, "select");
          disableInput(`#txtAPCeventID${a}_${i}`, false, "select");

          mandatoryInput(`#txtAPeventPercent${a}_${i}`, true, "text");
          disableInput(`#txtAPeventPercent${a}_${i}`, false, "text");
        }
        else {
          break;
        }

      }
      handleInputChange(`txtExceedraNoCodeRemarks${i}`, "");
      mandatoryInput(`#txtExceedraNoCodeRemarks${i}`, false, "text");
      disableInput(`#txtExceedraNoCodeRemarks${i}`, true, "text");

      if (isElementVisible(`#ddlCostElement${i}`)) {
        mandatoryInput(`#ddlCostElement${i}`, false, "select");
        disableInput(`#ddlCostElement${i}`, true, "select");
        handleInputChange(`ddlCostElement${i}`, "");
      }

    }

    // if (inputValues[`form_mode`].toLowerCase() == "view") {
    //   const fmImput = document.querySelector<HTMLInputElement>(
    //     `#fm1 :input`
    //   );
    //   if (fmImput?.disabled == true) {
    //     $("#fm1 :input").prop("disabled", true);
    //   }
    // }

  } else if (inputValues[`ddlCategory${i}`].toString() == "3") {
    if (isElementVisible(`#ddlCostElement${i}`)) {

      mandatoryInput(`#ddlCostElement${i}`, false, "select");
      disableInput(`#ddlCostElement${i}`, true, "select");
      handleInputChange(`ddlCostElement${i}`, "");
    }
  }


  //GRC
  if (inputValues[`ddlCategory${i}`].toString() == "3" && checkIsAPEventCode == "1") {
    mandatoryInput(`#ddlCostElement${i}`, false, "select");
    disableInput(`#ddlCostElement${i}`, false, "select");

    mandatoryInput(`#txtExceedraNoCodeRemarks${i}`, false, "text");

  }
  subCatInputOnChange(inputValues, i, "ddlNonDKSHInvolve", handleInputChange, inputValues[`ddlNonDKSHInvolve${i}`]);

  if (
    objectRequestor.country_code == "TH" ||
    objectRequestor.company_code == "AU84" ||
    objectRequestor.company_code == "AU85" ||
    objectRequestor.company_code == "AU91" ||
    objectRequestor.company_code == appConfig.FlexiClaimCSSC
  ) {
    elementDisplay(`#divAPCeventClaimable${i}`, false, "div");
  }
};
